import { render } from "./quotaDetails.vue?vue&type=template&id=599eb7b1&scoped=true"
import script from "./quotaDetails.vue?vue&type=script&lang=js"
export * from "./quotaDetails.vue?vue&type=script&lang=js"

import "./quotaDetails.vue?vue&type=style&index=0&id=599eb7b1&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-599eb7b1"

export default script